import axios from "axios";
import { authHeader } from "./auth-header";

const getAll = (keyword, page, perPage, id) => {
  return axios.get(process.env.REACT_APP_API_URL + `payout/list/${id}`, {
    headers: authHeader(),
    data: {},
    params: {
      keyword,
      page,
      perPage,
    },
  });
};

const getHostPayouts = (keyword, page, perPage, id) => {
  return axios.get(process.env.REACT_APP_API_URL + `payout/host/${id}`, {
    headers: authHeader(),
    data: {},
    params: {
      keyword,
      page,
      perPage,
    },
  });
};

const getPayoutListing = (keyword, page, perPage) => {
  return axios.get(process.env.REACT_APP_API_URL + `payout/listing`, {
    headers: authHeader(),
    data: {},
    params: {
      keyword,
      page,
      perPage,
    },
  });
};

const getPayoutDetails = (id) => {
  return axios.get(process.env.REACT_APP_API_URL + `payout/details/${id}`, {
    headers: authHeader(),
  });
};

const importPayouts = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(process.env.REACT_APP_API_URL + `payout/import`, formData, {
    headers: {
      ...authHeader(),
      "Content-Type": "multipart/form-data",
    },
  });
};

const exportPayoutListing = (filters = {}) => {
  return axios.get(process.env.REACT_APP_API_URL + `payout/export`, {
    headers: authHeader(),
    responseType: "blob",
    params: filters,
  });
};

const getPayoutCalculations = (transactionCode) => {
  return axios.post(process.env.REACT_APP_API_URL + `payout/calculations`, { transactionCode }, {
    headers: authHeader(),
  });
};

const updatePayoutComment = (id, data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `payout/comment/${id}`, data,
    {
      headers: authHeader(),
    },
  );
};

const methods = { getAll, getHostPayouts, getPayoutListing, getPayoutDetails, importPayouts, exportPayoutListing, getPayoutCalculations, updatePayoutComment };
export default methods;